<div class="disclaimer-content" [ngClass]="{ 'decrease-readability': hideALittle }">
	<h5 [translate]="message"></h5>
</div>
